import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
    name: 'stbyDate',
})
export class DatePipe implements PipeTransform {
    transform(value: any): string {
        if (isNaN(value)) {
            return value;
        } else if (dayjs.isDayjs(value)) {
            return value.toISOString();
        } else {
            return dayjs(value * 1000).toISOString();
        }
    }
}
